module.exports = __webpack_public_path__ + "media/images/tiedye_small-4e497e01.gif";